import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#121316] flex items-center justify-center px-4 grain relative">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-sm bg-white rounded-3xl p-8 relative">
        <Logo size="text-3xl" />
        <h1 className="mt-6 font-display font-bold text-2xl text-[#121316]">Admin sign in</h1>
        <p className="mt-1 text-sm text-[#5A5D65]">Manage bookings, waitlist & partners.</p>

        <label className="block mt-6"><span className="block text-sm font-bold text-[#121316] mb-1.5">Email</span>
          <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full h-12 px-4 rounded-xl border border-[#E5E0D8] outline-none focus:border-[#E05624] focus:ring-2 focus:ring-[#E05624]/20" /></label>
        <label className="block mt-4"><span className="block text-sm font-bold text-[#121316] mb-1.5">Password</span>
          <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full h-12 px-4 rounded-xl border border-[#E5E0D8] outline-none focus:border-[#E05624] focus:ring-2 focus:ring-[#E05624]/20" /></label>

        <button data-testid="admin-login-submit" type="submit" disabled={loading} className="mt-6 w-full h-13 py-3.5 rounded-full btn-saffron font-bold disabled:opacity-60">
          {loading ? "..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
